import PubSubUtils from '../../utils/pubsub-utils';
import APP_CONSTANTS from '../../constants';

export const publishBulkActionSubmitEvent = (data: object) => {
  /* publishing event to notify, the Bulk action is submitted */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.EVENT_BULKACTION, data);
};

export default { publishBulkActionSubmitEvent };
